import angular from 'angular';

import PackDetailsComponent from './pack-details.component';
import PackDetailsController from './pack-details.controller';


export default angular
  .module('pack-details', [])
  .controller('PackDetailsController', PackDetailsController)
  .component('packDetails', PackDetailsComponent);



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/pack-details/pack-details.module.js